import useGlobalRoutesHandler from "@/hooks/useGlobalHandleRouter";
import useGetAgentMenu from "@/services/hooks/agentMenu/useGetAgentMenu";
import useJourneyStore from "@/store/useStepStore";

const useStepper = () => {
  const { navigateTo, subRoute, navigate } = useGlobalRoutesHandler();
  const { setJourneyStep, totalSteps } = useJourneyStore();

  const {
    services: { getAllAgentMenu },
  } = useGetAgentMenu();

  return {
    states: { setJourneyStep, totalSteps },
    services: {
      getAllAgentMenu,
    },
    routing: { navigateTo, subRoute, navigate },
  };
};

export default useStepper;
